import { render, staticRenderFns } from "./walletList.vue?vue&type=template&id=51b8f99d&scoped=true"
import script from "./walletList.vue?vue&type=script&lang=js"
export * from "./walletList.vue?vue&type=script&lang=js"
import style0 from "./walletList.vue?vue&type=style&index=0&id=51b8f99d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8f99d",
  null
  
)

export default component.exports